<template>
    <div class="section row clearfix topmargin">
        <div class="col-md-12">
            <member-list
                    :items="member"
                    :fields="fields"
                    title="Pending Changes"
                    v-if="member.length > 0"
                    display-pending="true"
            ></member-list>
            <div v-if="loading">
                <b-spinner small></b-spinner>&nbsp;Loading changes...
            </div>
            <div v-if="!loading && member.length === 0">
                <h2>Pending Changes</h2>
                <p>Currently there are no members awaiting changes.</p>
            </div>
        </div>
    </div>
</template>

<script>
    import MemberList from '../../../components/Dashboard/MemberList'
    import { mapGetters, mapActions } from 'vuex'
    import config from '@/config/config'
    import axios from 'axios'

    export default {
        name: 'PendingActions',
        components: {MemberList},
        data () {
            return {
                loading: true,
                member: [],
                fields: [
                    {
                        key: 'quickView',
                        sortable: false,
                        label: ''
                    },
                    {
                        key: 'request_type',
                        label: 'Request',
                        formatter: function (value) {
                            return titleCase(value.replace('_', ' '))
                        }
                    },
                    {
                        key: 'group',
                        sortable: true
                    },
                    {
                        key: 'firstName',
                        sortable: true
                    },
                    {
                        key: 'lastName',
                        sortable: true
                    },
                    {
                        key: 'cert',
                        sortable: false,
                        'label': 'Member ID'
                    },
                    {
                        key: 'city',
                        sortable: true
                    },
                    {
                        key: 'stateName',
                        sortable: true,
                        'label': 'State'
                    },
                    {
                        key: 'tools',
                        sortable: false
                    }
                ]
            }
        },
        computed: {
            ...mapGetters(['currentMember', 'pendingActions']),
        },
        methods: {
            ...mapActions(['getMemberData', 'getPendingActions']),
            pending () {
                this.loading = false
                this.pendingActions.forEach(change => {
                    if (change.cert) {
                        axios.get(config.apiUrl() + 'member/' + change.cert).then(response => {
                            this.member.push(response.data)
                        }, err => {
                            this.error = err.isNull
                        })
                    } else {
                        let data = change.change_requested
                        data.id = change.id
                        data.group = change.group_code.substring(3)
                        data.cert = 'Unassigned'
                        data.request_type = change.request_type
                        this.member.push(data)
                    }
                })
            }
        },
        beforeMount () {
            this.getPendingActions()
        },
        watch: {
            pendingActions (val) {
                if (val && val.length > 0) {
                    this.pending();
                }
            }
        }
    }

    function titleCase(str) {
        str = str.toLowerCase().split(' ');
        for (let i = 0; i < str.length; i++) {
            str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
        }
        return str.join(' ');
    }
</script>

<style scoped>

</style>
